export default __webpack_public_path__ + "static/media/sfondoEmail.5769979d.jpg";